export default __webpack_public_path__ + "static/media/CameraImg.d5da7cd7.jpg";